// Flags from https://github.com/Yummygum/flagpack-core
import type { LanguageCode } from "@towni/common";
import { assertNever } from "@towni/common";
import { LanguageFlag_de } from "./de-language-flag";
import { LanguageFlag_en } from "./en-language-flag";
import { LanguageFlag_sv } from "./sv-language-flag";

const LanguageFlag = (props: {
    readonly language: LanguageCode;
    readonly size?: number;
    readonly className?: string;
}) => {
    const size = props.size ?? 1;
    switch (props.language) {
        case "sv":
            return <LanguageFlag_sv size={size} className={props.className} />;
        case "de":
            return <LanguageFlag_de size={size} className={props.className} />;
        case "en":
            return <LanguageFlag_en size={size} className={props.className} />;
        default:
            assertNever(props.language);
    }
};

export { LanguageFlag };
